// @flow
import * as React from 'react';
import {Chip} from "@mui/material";
import _ from "lodash";
import { Smiley, SmileyMeh, SmileyAngry  } from '@phosphor-icons/react';

type Props = {
  sentiment?: string | null,
  size?: 'small' | 'medium',
};
export const CallSentiment = ({sentiment, size}: Props) => (
  <Chip color={getColorBySentiment(sentiment)}
        icon={getIcon(sentiment)}
        size={size}
        sx={{borderRadius: '12px', px: size !== 'small' ? 2 : 0, py: size !== 'small' ? 1 : 0}}
        label={_.upperFirst(sentiment?.toLowerCase())}/>
)


const getIcon = (val?: string | null) => {
  if (val === 'NEGATIVE') {
    return <SmileyAngry size={16} color="currentColor" weight={'bold'} />
  }
  if (val === 'POSITIVE') {
    return <Smiley size={16} color="currentColor" weight={'bold'} />
  }
  return <SmileyMeh size={16} color="currentColor" weight={'bold'} />
}

const getColorBySentiment = (val?: string | null) => {
  switch (val) {
    case 'NEGATIVE': return 'error';
    case 'POSITIVE': return 'success';
    default: return 'info';
  }
}
